import { FC } from 'react';

import { H2 } from '@rikstv/shared-components';

import { Quote } from './Quote';

import styles from './Quotes.module.css';

const SellingPoints: FC = () => {
  return (
    <section className={styles.quotes}>
      <H2 className={styles.title}>Dette sier kundene våre</H2>
      <div className={styles.wrapper}>
        <Quote author="Nina" idx={1} stars={5}>
          Her får du mest for pengene. Det er også ryddig og enkelt å bruke. Kan anbefale på det varmeste.
        </Quote>
        <Quote author="Lillian" idx={2} stars={5}>
          TV-pakkene de tilbyr passer mitt behov bedre. Mye for pengene.
        </Quote>
        <Quote author="Kenneth" idx={3} stars={4}>
          Stort sett lettvint og man får hva man betaler for.
        </Quote>
        <Quote author="Tina" idx={4} stars={5}>
          Strim er helt perfekt for oss. Enkelt og fungerer helt supert med Apple TV!
        </Quote>
      </div>
    </section>
  );
};

export default SellingPoints;
